import React, { FC } from 'react';

interface ShareInfoProps {
  amount: number;
  text: string;
}

const ShareInfo: FC<ShareInfoProps> = ({ amount, text }) => {
  return (
    <div className="share-info">
      <span>
        {text}
        {amount}.
      </span>
    </div>
  );
};

export default ShareInfo;
